import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MDText } from 'i18n-react';
import LinkedEntitiesCellBlock from '../../LinkedEntitiesCellBlock';
import getPropsFromEntity from './getPropsFromEntity';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';

const RfiLinkedEntitiesCellBlock = ({ entity, env, region, projectId, ...props }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));

  return (
    <LinkedEntitiesCellBlock
      {...props}
      {...getPropsFromEntity({ entity, env, region, projectId, T })}
    />
  );
};

RfiLinkedEntitiesCellBlock.propTypes = {
  /**
   * The RF entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    identifier: PropTypes.string
  }).isRequired,
  /**
   * The environment. One of `ENVS` values.
   */
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  /**
   * The region. One of `REGIONS` values.
   */
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  /**
   * The project ID
   */
  projectId: PropTypes.string.isRequired
};

export default RfiLinkedEntitiesCellBlock;
